import { render, staticRenderFns } from "./PrimaryMarketTrading.vue?vue&type=template&id=9f81133a&"
import script from "./PrimaryMarketTrading.vue?vue&type=script&lang=js&"
export * from "./PrimaryMarketTrading.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryMarketTrading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports